import { GameSpineUtil } from "./GameSpineUtil";
export class GameSymbolUtil {
    /**
     * Iterate over each symbol number, per column and variant.
     */
    static forEachNumber(fn) {
        for (let column = 0; column < this.SYMBOL_COLUMNS; ++column) {
            for (let variant = 0; variant < this.SYMBOL_VARIANTS; ++variant) {
                const number = GameSymbolUtil.variantToNumber(column, variant);
                fn(number, column, variant);
            }
        }
    }
    /**
     * Convert a column and variant to their symbol number.
     */
    static variantToNumber(column, variant) {
        return column * this.SYMBOL_VARIANTS + variant + 1;
    }
    /**
     * Convert a symbol number to its variant.
     */
    static numberToVariant(number) {
        return (number - 1) % this.SYMBOL_VARIANTS;
    }
    /**
     * Convert a symbol number to its column.
     */
    static numberToColumn(number) {
        return Math.min(Math.floor((number - 1) / this.SYMBOL_VARIANTS), this.SYMBOL_COLUMNS - 1);
    }
    /**
     * Set a symbol spine to have a combined column and variant skin based on its number.
     */
    static setNumberSkin(spine, number) {
        const column = GameSymbolUtil.numberToColumn(number);
        const variant = GameSymbolUtil.numberToVariant(number);
        GameSpineUtil.setSkin(spine, `variant/${this.isVariant(variant) ? variant : 0}`, `column/${this.isColumn(column) ? column : 0}`);
    }
    /**
     * Set a symbol spine to have a variant skin.
     */
    static setVariantSkin(spine, variant) {
        GameSpineUtil.setSkin(spine, `variant/${this.isVariant(variant) ? variant : 0}`);
    }
    /**
     * Set a symbol spine to have a column skin.
     */
    static setColumnSkin(spine, column) {
        GameSpineUtil.setSkin(spine, `column/${this.isColumn(column) ? column : 0}`);
    }
    /**
     * Set a symbol spine to have a joker skin.
     */
    static setJokerSkin(spine) {
        GameSpineUtil.setSkin(spine, "wild");
    }
    /**
     * Set a symbol spine to have a super joker skin.
     */
    static setSuperJokerSkin(spine) {
        GameSpineUtil.setSkin(spine, "superwild");
    }
    /**
     * Set a symbol spine to have a free spin skin.
     */
    static setFreeSpinSkin(spine) {
        GameSpineUtil.setSkin(spine, "freespin");
    }
    /**
     * Set a symbol spine to have a scatter skin.
     */
    static setScatterSkin(spine) {
        GameSpineUtil.setSkin(spine, "scatter");
    }
    static isVariant(variant) {
        return variant >= 0 && variant < GameSymbolUtil.SYMBOL_VARIANTS;
    }
    static isColumn(column) {
        return column >= 0 && column < GameSymbolUtil.SYMBOL_COLUMNS;
    }
}
/**
 * The number of distinct symbol columns.
 */
GameSymbolUtil.SYMBOL_COLUMNS = 5;
/**
 * The number of distinct symbol variants per column.
 */
GameSymbolUtil.SYMBOL_VARIANTS = 10;
//# sourceMappingURL=GameSymbolUtil.js.map